import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import { debug } from 'console';

declare var initEditor: any;
declare var SetPropertyPhotos: any;
declare var getWebRemarks: any;

@Component({
  selector: 'app-set-property-photo',
  templateUrl: './set-property-photo.component.html',
  styleUrls: ['./set-property-photo.component.css']
})
export class SetPropertyPhotoComponent implements OnInit {
  propertyId: any = '';
  src: any = '';
  apiUrl: any = '';
  propertyForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  isEdit: Boolean = false;
  country: any[] = [];
  state: any[] = [];
  city: any[] = [];
  areas: any[] = [];
  district: any[] = [];
  subArea: any[] = [];
  subSubArea: any[] = [];
  categories: any[] = [];
  facilities: any[] = [];
  facility: any[] = [];
  agents: any[] = [];

  properties: any = {
    countryId: 1,
    stateId: 1,
    cityId: 2,
    districtId: 1,
    areaId: '',
    userId: '',
    subAreaId: '',
    subSubAreaId: '',
    propertyRefNo: '',
    propertyType: '',
    listingAgent: '',
    listingAgentEmail: '',
    listingAgentPhone: '',
    unitReferenceNo: '',
    rentType: '',
    furnishing: '',
    propertyName: '',
    propertyTitle: '',
    permitNo: '',
    price: '',
    bedrooms: '',
    noOfBathroom: '',
    companyName: '',
    featured: 0,
    facility: [],
    webRemarks: '',
    unitBuiltupArea: '',
    images: [],
    longitude: '',
    latitude: ''
  };
  subAreaList: any = [];
  subSubAreaList: any = [];
  propertyImages: any = { id: '', basc64: '', imageUrl: '', index: -1 };
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.propertyId = route.snapshot.params['id'];
  }

  agentId: any = '';
  isAgent: Boolean = false;

  ngOnInit() {
    const roles = localStorage.getItem("role");
       
    this.apiUrl = this.config.apiRootUrl;    

    if (this.agentId > 0) {
      this.properties.userId = this.agentId;
    }
    this.getPropertyPhotoDetail(this.propertyId);
  }

  

  getPropertyPhotoDetail(id) {
    this.servicesComponent.getPropertyPhotoDetail(id)
      .then((response: any) => {
        if (response.success) {
          this.properties = response.receiveObj;
          SetPropertyPhotos(response.receiveObj.propertyRefNo, response.receiveObj.cdnCount);
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }
    
  updateProperty(form) {
    this.submitted = false;
    if (form.valid) {
      this.properties.facility = this.facilities;
      //if (this.properties.images.length == 0) {
      //  this.submitted = true;
      //  return
      //}
      this.properties.webRemarks = getWebRemarks();
      this.servicesComponent.saveProperty(this.properties)
        .then((response: any) => {
          if (response.receiveObj.success) {
            this.router.navigate(['./property']);
            this.toastr.success('property update successfully.', 'Success!');
          }
        })
        .catch(error => {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  

  reInit() {
    this.propertyImages = { id: '', basc64: '', imageUrl: '', index: -1 };
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  deleteImage(value, index) {
    this.servicesComponent.deletePropertyImage(value)
      .then((response: any) => {
        if (response.receiveObj == true) {
          this.properties.images.splice(index, 1);
          this.toastr.success('property image delete successfully.', 'Success!');
        }
      })
      .catch(error => {
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  deleteImageArray(index) {
    if (this.properties.images.length > 0) {
      this.properties.images.splice(index, 1);
    }
  }

  
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/propertiesManagement/property/set-property-photo/set-property-photo.component.ts